import Maths3 from "oc-threejs/Maths3";
import BaseType from "./BaseType";
import Scenes from "oc-threejs/Scenes";
import BoxRuler from "./BoxRuler";

export default class ArrangementRuler extends BaseType(THREE.Group) {

    rulers = [];
    hideForSAOPASS = true;

    constructor(vsData) {
        super(vsData);
        this.visible = APP.settings.getBool('ui_zeige_masse');
    }

    vsUpdate() {
        if (this.isVsChanged('size',a=>a.schraenke.map(s=>({box:s.box,position:s.position,quaternion:s.quaternion})))) {
            const schraenke = []; // this.vsData.schraenke;
            if (schraenke.length==0) {

                this.setRulerCount(0);

            } else if (schraenke.length==1) {

                this.setRulerCount(1);

                const ruler = this.rulers[0];
                const desc = ruler.description;
                desc.xbottom.show = true;
                desc.xbottom.rulerOffset.z = 40;
                desc.yright.show = true;
                desc.yright.rulerOffset.x = 20;
                desc.zbottom.show = true;
                desc.zbottom.rulerOffset.x = 20;
                ruler.updateBox(schraenke[0].getBox3World());

            } else {

                this.setRulerCount(schraenke.length+1);

                const ruler = this.rulers[0];
                const desc = ruler.description;
                desc.xtop.show = true;
                desc.yleft.show = true;
                desc.yright.show = true;
                desc.ztop.show = true;

                const unionBox = new THREE.Box3();
                schraenke.forEach(s => s.getBox3World(unionBox));
                ruler.updateBox(unionBox);

                schraenke.forEach((schrank,i)=>{
                    const ruler = this.rulers[i+1];
                    const desc = ruler.description;
                    if (Math.abs(schrank.drehungAbsolut)<10) {
                        desc.zbottom.show = true;
                        desc.xbottom.show = false;
                    } else {
                        desc.zbottom.show = false;
                        desc.xbottom.show = true;
                        desc.xbottom.textQuaternion = Maths3.quaternion.y90;
                    }
                    ruler.updateBox(schrank.getBox3World());
                });

            }
        }
    }

    setRulerCount(count) {
        if (this.rulers.length!==count) {
            this.rulers.forEach(r=>Scenes.remove(r));
            this.rulers = _.range(0,count).map(()=>{
                const ruler = new BoxRuler();
                this.add(ruler);
                return ruler;
            });
        }
    }

}
